// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3JKiu","spacer":"style_spacer__3TTr5"};